import type { Correlation } from 'state/quotes/correlations/correlations.model';
import { QuoteWorkspaceType } from 'state/workspaces/model';

export type CorrelationActions =
  | CorrelationsChanged
  | SaveCorrelationsInputs
  | SaveCorrelationsInputsFailed
  | SaveCorrelationsInputsSucceeded;

export function correlationsChanged(tabId: string, correlations: Omit<Correlation, 'saveCorrelation'>) {
  return {
    type: 'CORRELATIONS_CHANGED' as const,
    tabId,
    correlations,
  };
}
type CorrelationsChanged = ReturnType<typeof correlationsChanged>;

export function saveCorrelationsInputs(tabId: string, workspace: QuoteWorkspaceType) {
  return {
    type: 'SAVE_CORRELATION_INPUTS' as const,
    tabId,
    workspace,
  };
}
type SaveCorrelationsInputs = ReturnType<typeof saveCorrelationsInputs>;

export function saveCorrelationsInputsFailed(tabId: string, workspace: QuoteWorkspaceType) {
  return {
    type: 'SAVE_CORRELATION_INPUTS_FAILED' as const,
    tabId,
    workspace,
  };
}
type SaveCorrelationsInputsFailed = ReturnType<typeof saveCorrelationsInputsFailed>;

export function saveCorrelationsInputsSucceeded(tabId: string, workspace: QuoteWorkspaceType) {
  return {
    type: 'SAVE_CORRELATION_INPUTS_SUCCEEDED' as const,
    tabId,
    workspace,
  };
}
type SaveCorrelationsInputsSucceeded = ReturnType<typeof saveCorrelationsInputsSucceeded>;
